'use strict';
/* jshint ignore:start */
var orderreview = {
	orderReviewEvent: function () {
		if ($('input[name=basketData]').length > 0) {
			var cart = JSON.parse($('input[name=basketData]').val());
			var obj = {
			'button_id': cart.button_id,
			'event': 'checkout',
			'checkout_type': cart.checkout_type,
			'order_delivery_total': cart.order_delivery_total,
			'order_delivery_type': cart.order_delivery_type,
			'order_gifting_total': cart.order_gifting_total,
			'order_gifting_type': cart.order_gifting_type,
			'order_ID': cart.order_ID,
			'order_item_quantity': cart.order_item_quantity,
			'order_items_total': cart.order_items_total,
			'order_total_price': cart.order_total_price,
			'voucher':cart.voucher,
			'3rdParty': cart.thirdParty,
			'checkout_stock_status': cart.checkout_stock_status || ''
			};
			$.extend(obj, getOrderProducts(cart));
			$.extend(obj, getOrderHampers(cart));
			dataLayer.push(obj);

			if (cart && cart.events && cart.events.length) {
				for (var i = cart.events.length - 1; i >= 0; i--) {
					dataLayer.push(cart.events[i]);
				}
			}
		}
	}
}

function getOrderProducts(cart) {
	var productArray = [];
	var products = cart.product;
	for (var i = 0; i < products.length; i++) {
		// object to be pushed
		var objProduct = {
			'product_ID': products[i].product_ID,
			'order_discount_product_ID': '',
			'order_discount_product_value': '',
			'product_brand': products[i].product_brand,
			'product_category': products[i].product_category,
			'product_delivery': products[i].product_delivery,
			'product_delivery_cost': products[i].product_delivery_cost,
			'product_discount': '',
			'product_gifting_occasion': '',
			'product_gifting_selection': '',
			'product_hierarchy': products[i].product_hierarchy,
			'product_name': products[i].product_name,
			'product_price': products[i].product_price,
			'product_price_old': products[i].product_price_old,
			'product_quantity': products[i].product_quantity,
			'product_SKU': products[i].product_SKU,
			'product_stock_status': products[i].product_stock_status,
			'product_variant': products[i].product_variant,
			'product_vat': products[i].product_vat,
			'product_image': products[i].product_image,
			'product_url': products[i].product_url,
			'item_list_name': products[i].item_list_name
		};
		productArray.push(objProduct);
	}
	var productObj = {product: productArray};
	return productObj;
}

function getOrderHampers(cart) {
	var hamperArray = [];
	var hampers = cart.hamper;
	for (var i = 0; i < hampers.length; i++) {
		// object to be pushed
		var objHamper = {
			'hamper_ID': hampers[i].hamper_ID,
			'order_discount_hamper_ID': hampers[i].order_discount_hamper_ID,
			'order_discount_hamper_value': hampers[i].order_discount_hamper_value,
			'hamper_brand': hampers[i].hamper_brand,
			'hamper_category': hampers[i].hamper_category,
			'hamper_delivery': hampers[i].hamper_delivery,
			'hamper_delivery_cost': hampers[i].hamper_delivery_cost,
			'hamper_delivery_city': hampers[i].hamper_delivery_city,
			'hamper_delivery_country': hampers[i].hamper_delivery_country,
			'hamper_delivery_gifting_product': hampers[i].hamper_delivery_gifting_product,
			'hamper_delivery_gifting_added': hampers[i].hamper_delivery_gifting_added,
			'hamper_delivery_gifting_card': hampers[i].hamper_delivery_gifting_card,
			'hamper_delivery_gifting_cost': hampers[i].hamper_delivery_gifting_cost,
			'hamper_delivery_gifting_type': hampers[i].hamper_delivery_gifting_type,
			'hamper_delivery_gifting_wrap': hampers[i].hamper_delivery_gifting_wrap,
			'hamper_delivery_postcode': hampers[i].hamper_delivery_postcode,
			'hamper_delivery_service_date': hampers[i].hamper_delivery_service_date,
			'hamper_delivery_service_event': hampers[i].hamper_delivery_service_event,
			'hamper_delivery_service_selection': hampers[i].hamper_delivery_service_selection,
			'hamper_discount': hampers[i].hamper_discount,
			'hamper_gifting_occasion': hampers[i].hamper_gifting_occasion,
			'hamper_gifting_selection': hampers[i].hamper_gifting_selection,
			'hamper_hierarchy': hampers[i].hamper_hierarchy,
			'hamper_name': hampers[i].hamper_name,
			'hamper_price': hampers[i].hamper_price,
			'hamper_price_old': hampers[i].hamper_price_old,
			'hamper_quantity': hampers[i].hamper_quantity,
			'hamper_SKU': hampers[i].hamper_SKU,
			'hamper_stock_status': hampers[i].hamper_stock_status,
			'hamper_variant': hampers[i].hamper_variant,
			'hamper_vat': hampers[i].hamper_vat,
			'hamper_voucher': hampers[i].hamper_voucher,
			'hamper_details_viewed': hampers[i].hamper_details_viewed,
			'hamper_image': hampers[i].hamper_image,
			'hamper_set_capacity': hampers[i].hamper_set_capacity,
			'hamper_set_items_added': hampers[i].hamper_set_items_added,
			'hamper_set_name': hampers[i].hamper_set_name,
			'hamper_set_price': hampers[i].hamper_set_price,
			'hamper_set_size': hampers[i].hamper_set_size,
			'hamper_set_SKU': hampers[i].hamper_set_SKU,
			'hamper_set_type': hampers[i].hamper_set_type,
			'product': getHamperProducts(hampers[i])
		};
		hamperArray.push(objHamper);
	}
	var productObj = {hamper: hamperArray};
	return productObj;
}

function getHamperProducts(hamper) {
	var productArray = [];
	var products = hamper.product;
	for (var i = 0; i < products.length; i++) {
		// object to be pushed
		var objProduct = {
			'product_ID': products[i].product_ID,
			'product_brand': products[i].product_brand,
			'product_category': products[i].product_category,
			'product_hierarchy': products[i].product_hierarchy,
			'product_name': products[i].product_name,
			'product_price': products[i].product_price,
			'product_price_old': products[i].product_price_old,
			'product_quantity': products[i].product_quantity,
			'product_SKU': products[i].product_SKU,
			'product_stock_status': products[i].product_stock_status,
			'product_variant': products[i].product_variant,
			'product_vat': products[i].product_vat
		};
		productArray.push(objProduct);
	}
	return productArray;
}
module.exports = orderreview
/* jshint ignore:end */
